export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9065.d7b2f8c3.jpg";